module.exports = __webpack_public_path__ + "img/resp_rotate1.2d20ed7c.png";